import {ProviderMetricsFilterValue} from "./domain";
import {MultiFilterButton, SimpleDropdown} from "../../../common";
import React, {Dispatch, useEffect, useState} from "react";
import {ProviderMetricsPageAction} from "./ProviderMetricsPage";
import DatePicker from "react-datepicker";
import {DatePickerInput} from "../../../common/component/DatePickerInput";
import { ProviderMetricsReportTypeMap } from "../domain";

type ProviderMetricsFilterProps = {
    initFilterValue: ProviderMetricsFilterValue;
    dispatch: Dispatch<ProviderMetricsPageAction>
}

const ProviderMetricsFilter = ({initFilterValue, dispatch}: ProviderMetricsFilterProps) => {
    const [filterValue, setFilterValue] = useState({...initFilterValue});
    useEffect(() => {
        setFilterValue(initFilterValue);
    }, [initFilterValue])
    const onFilterUpdate = (fieldName: string, fieldValue: any) => {
        setFilterValue({...filterValue, [fieldName]: fieldValue})
    }

    return (
        <MultiFilterButton<ProviderMetricsFilterValue>
            filterValue={filterValue}
            setFilterValue={setFilterValue}
            emptyFilterValue={{
                reportType: "",
                reportAvailableDateFrom: null,
                reportAvailableDateTo: null,
                reportPeriod: null,
            }}
            dispatchSetFilterValue={(val) => dispatch({type: "SET_FILTER", filter: val})}
            filterOptions={[
                {
                    label: "Report Type",
                    component: <SimpleDropdown
                        options={ProviderMetricsReportTypeMap}
                        selected={filterValue.reportType}
                        minWidth={"7rem"}
                        textColor={"gray-600"}
                        setSelected={(newValue) => onFilterUpdate("reportType", newValue)}/>
                },
                {
                    label: "Report Period",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        dateFormat={"MMMM/yyyy"}
                        showMonthYearPicker
                        selected={filterValue.reportPeriod || null}
                        onChange={(newValue: Date | null) => onFilterUpdate("reportPeriod", newValue)}
                        customInput={<DatePickerInput
                            fieldName="reportPeriod"
                            value={undefined}
                        />}
                    />
                },
                {
                    label: "Report Available Date From",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.reportAvailableDateFrom || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("reportAvailableDateFrom", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="reportAvailableDateFrom"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("reportAvailableDateFrom", newValue)}
                        />}
                    />
                },
                {
                    label: "Report Available Date To",
                    component: <DatePicker
                        wrapperClassName="w-full"
                        selected={filterValue.reportAvailableDateTo || null}
                        onSelect={(newValue: Date | null) => onFilterUpdate("reportAvailableDateTo", newValue)}
                        onChange={() => {}}
                        customInput={<DatePickerInput
                            fieldName="reportAvailableDateTo"
                            value={undefined}
                            onFinish={(newValue: Date | null) => onFilterUpdate("reportAvailableDateTo", newValue)}
                        />}
                    />
                },
            ]}
        />
    )
}
export default ProviderMetricsFilter;